<template>
  <gg-card>
    <gg-card-text class="pa-4">
      <v-row align="center" justify="space-between" no-gutters>
        <v-col cols="auto">
          <div class="d-flex align-center">
            <h2 class="text-h5 font-weight-medium mr-3 mb-0">
              {{ title }}
            </h2>
            <v-chip small>
              {{ websitesCount }} {{ websitesCount === 1 ? 'website' : 'websites' }}
            </v-chip>
          </div>
        </v-col>

        <v-col cols="auto">
          <div class="d-flex align-center">
            <gg-text-field
              v-model="searchQuery"
              placeholder="Quick search"
              hide-details
              class="search-field mr-3"
              @input="onSearchInput"
            >
              <template v-slot:prepend-inner>
                <v-icon>mdi-magnify</v-icon>
              </template>
            </gg-text-field>

            <slot name="filter"></slot>

            <v-btn
              text
              class="ml-3 text-none"
              @click="onCollapseAll"
            >
              <v-icon left small>{{ collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
              {{ collapsed ? 'Expand All' : 'Collapse All' }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'WebsitesGroupConptoller',
  props: {
    collapsed: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: 'My Websites',
    },
    websitesCount: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      searchQuery: '',
    }
  },
  methods: {
    onSearchInput () {
      this.$emit('search', this.searchQuery)
    },
    onCollapseAll () {
      this.$emit('collapse-all', !this.collapsed)
    },
  },
}
</script>

<style scoped>
.search-field {
  max-width: 260px;
}
</style>
